<script setup>
import NavLink from "@/Components/NavLink.vue";
import {route} from "ziggy-js";
import Button from "@/Components/Button.vue";
</script>
<template>
    <NavLink :href="route('referral.index')">
        <Button
            :text="$t('Participate')"
            class="text-sm w-m-min font-medium"
            type="primary"
        ></Button>
    </NavLink>
</template>
